import ConsentReactor from '@modules/modules/CookieConsent/components/ConsentReactor';
import React from 'react';

const PiwikConsentReactor = () => (
  <ConsentReactor
    /**
      execute cant be used with piwik
      the script for piwik MUST BE implemented
      exactly after body tag (mandatory) in the DOM
    */
    execute={() => {}}
    services={[]}
  />
);

export default PiwikConsentReactor;
